import React, { useState } from 'react';
import TextInput from "../../interactive/inputs/TextInput";
const KitchenSinkInputs = () => {
    const [textInputValue, setTextInputValue] = useState('');
    return /*#__PURE__*/ React.createElement("section", { className: "kitchen-sink__section" }, /*#__PURE__*/ React.createElement("h2", { id: "inputs", className: "kitchen-sink__section-heading" }, "Inputs"), /*#__PURE__*/ React.createElement("div", { className: "kitchen-sink__sub-section" }, /*#__PURE__*/ React.createElement("h3", { className: "kitchen-sink__sub-section-heading" }, "Text input"), /*#__PURE__*/ React.createElement(TextInput, { info: "info text", label: "Text input label", name: "text-input", onChange: e => setTextInputValue(e.target.value), placeholder: "Placeholder text", value: textInputValue }), /*#__PURE__*/ React.createElement("pre", { className: "kitchen-sink__code" }, /*#__PURE__*/ React.createElement("code", null, `<TextInput
  info="info text"
  label="Text input label"
  name="text-input"
  onChange={(e) => setTextInputValue(e.target.value)}
  placeholder="Placeholder text"
  value={textInputValue}
/>`)), /*#__PURE__*/ React.createElement(TextInput, { label: "Disabled text input", disabled: true, placeholder: "Disabled text input" }), /*#__PURE__*/ React.createElement("pre", { className: "kitchen-sink__code" }, /*#__PURE__*/ React.createElement("code", null, `<TextInput
  label="Disabled text input"
  disabled={true}
  placeholder="Disabled text input"
/>`)), /*#__PURE__*/ React.createElement(TextInput, { error: "Error message", label: "Text input with error", name: "text-input-error", onChange: () => { }, placeholder: "Text input with error", value: textInputValue }), /*#__PURE__*/ React.createElement("pre", { className: "kitchen-sink__code" }, /*#__PURE__*/ React.createElement("code", null, `<TextInput
  error="Error message"
  label="Text input with error"
  name="text-input-error"
  onChange={() => {}}
  placeholder="Text input with error"
  value={textInputValue}
/>`))));
};
export default KitchenSinkInputs;
